import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./utils";
import type {
  ClauseTemplatesGetResponse,
  SectionTemplatesGetResponse,
  DocumentTemplatesGetResponse,
  DocumentTemplateStatesGetResponse,
} from "../../../api/src/templates/route";

export const templatesApi = createApi({
  reducerPath: "templatesApi",
  baseQuery,
  endpoints: (builder) => ({
    getClauseTemplates: builder.query<ClauseTemplatesGetResponse, void>({
      query: () => ({ url: `templates/clause-templates`, method: "GET" }),
    }),
    getSectionTemplates: builder.query<SectionTemplatesGetResponse, void>({
      query: () => ({ url: `templates/section-templates`, method: "GET" }),
    }),
    getDocumentTemplates: builder.query<DocumentTemplatesGetResponse, void>({
      query: () => ({ url: `templates/document-templates`, method: "GET" }),
    }),
    getDocumentTemplateStates: builder.query<
      DocumentTemplateStatesGetResponse,
      string
    >({
      query: (documentTemplateId) => ({
        url: `templates/document-template-states/${documentTemplateId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetClauseTemplatesQuery,
  useGetSectionTemplatesQuery,
  useGetDocumentTemplatesQuery,
  useGetDocumentTemplateStatesQuery,
} = templatesApi;
